import React from "react";
import { UploadSimple } from "@phosphor-icons/react";
import { PhotoTile } from "@/components/PhotoTile";

export function JobPhotosCard({ job, uploadPhase, setUploadPhase, uploading, onUpload, onRemovePhoto, canRemove }) {
  return (
    <div className="rmms-card p-5">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <div className="overline">Photos & evidence</div>
        <div className="flex items-center gap-2">
          <div className="inline-flex border border-slate-200 rounded-sm overflow-hidden" data-testid="job-photo-phase-picker">
            {[["before", "Before"], ["during", "During"], ["after", "After"]].map(([v, l]) => (
              <button key={v} type="button" onClick={() => setUploadPhase(v)} data-testid={`job-photo-phase-${v}`}
                className={`px-2.5 h-7 text-[10px] font-heading uppercase tracking-wider transition-colors ${
                  uploadPhase === v ? "bg-slate-900 text-white" : "bg-white text-slate-600 hover:bg-slate-50"
                }`}>{l}</button>
            ))}
          </div>
          <label data-testid="job-photo-upload-label" className="text-xs inline-flex items-center gap-1.5 cursor-pointer h-8 px-3 border border-slate-200 rounded-sm hover:bg-slate-50 transition-colors">
            <UploadSimple size={12} weight="bold" />
            {uploading ? "Uploading…" : "Upload"}
            <input data-testid="job-photo-upload-input" type="file" accept="image/*" multiple onChange={onUpload} className="hidden" />
          </label>
        </div>
      </div>
      {(job.photos || []).length === 0 ? (
        <div className="text-sm text-slate-400 py-6 text-center border border-dashed border-slate-200 rounded-sm">No photos yet. Pick a phase above, then upload.</div>
      ) : (
        <div className="space-y-4">
          {["before", "during", "after"].map((ph) => {
            const phasePhotos = (job.photos || []).filter((fid) => (job.photo_meta?.[fid]?.phase || "during") === ph);
            if (!phasePhotos.length) return null;
            return (
              <div key={ph} data-testid={`job-photos-${ph}`}>
                <div className="overline mb-1.5 text-[10px] flex items-center gap-1.5">
                  {ph} <span className="font-mono-data text-slate-400">· {phasePhotos.length}</span>
                </div>
                <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-5 gap-2">
                  {phasePhotos.map((fid) => (
                    <PhotoTile key={fid} fileId={fid} onRemove={onRemovePhoto} canRemove={canRemove} />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
